import {COMPANY_ROLE, COMPANY_ROLE_NAME, STATUS, STATUS_NAME} from "@/model/company";

export interface ICompanyCooperate {
  id: string;
  company_id: string,
  cooperate_company_id: string,
  cooperate_company_name: string,
  role_id: COMPANY_ROLE,
  status: STATUS,
  type: number,
}

export class CompanyCooperateDTO implements ICompanyCooperate {
  id: string;
  company_id: string;
  cooperate_company_id: string;
  cooperate_company_name: string;
  role_id: COMPANY_ROLE;
  status: STATUS;
  type: number;
}

export default class CompanyCooperate extends CompanyCooperateDTO {
  constructor(dto?: CompanyCooperateDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      company_id: "",
      cooperate_company_id: "",
      cooperate_company_name: "",
      role_id: COMPANY_ROLE.WITNESS,
      status: null,
      type: null,
    });
  }

  get roleName() {
    return COMPANY_ROLE_NAME[this.role_id];
  }

  public getStatusName(status) {
    return STATUS_NAME[status];
  }
}
